import { defineAsyncComponent } from 'vue';

export const TableFilterInputerList = defineAsyncComponent(() => import('./TableFilterInputerList.vue'));
export const TableTopInputerList = defineAsyncComponent(() => import('./TableTopInputerList.vue'));